import React, { useEffect } from 'react';
import FullWidthLayout from '../layouts/FullWidthLayout';
import { ROUTES } from '../config/routes';
import './LoginPage.css';
import Container from '../components/Container';
import { useAppContext } from '../context/AppContext';
import Typography from '@mui/joy/Typography';
import * as Api from '../services/api';

const LogoutPage = () => {
  const { setAndee } = useAppContext();

  useEffect(() => {
    // TODO: Revisit this. I'm not sure if this is the best way to do this.
    Api.logout()
      .then(() => setAndee(null))
      .catch(e => console.error(e))
      .finally(() => window.location.href = window.location.origin);
  }, []);

  return (
    <FullWidthLayout>
      <Container>
        <Typography>
          <p style={{ textAlign: 'center' }}>
            Signing out and redirecting you home. Hang tight!
          </p>
        </Typography>
      </Container>
    </FullWidthLayout>
  );
};

export default LogoutPage;
